define('OutSystems/ClientRuntime/modules/Storage/StorageNaming',["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.setDefaultStorageNamespace = exports.getDefaultStorageNamespace = exports.OS_STORAGE_PREFIX = void 0;
    exports.OS_STORAGE_PREFIX = "$OS_";
    var defaultNameSpace = "OS";
    function getDefaultStorageNamespace() {
        return defaultNameSpace;
    }
    exports.getDefaultStorageNamespace = getDefaultStorageNamespace;
    function setDefaultStorageNamespace(storageNamespace) {
        defaultNameSpace = storageNamespace;
    }
    exports.setDefaultStorageNamespace = setDefaultStorageNamespace;
});
//# sourceMappingURL=StorageNaming.js.map;
